export default { sha: '95308c46374286d36ac1feb95fcdabf6d5371b4c', buildNumber: 'undefined' }
